import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import SearchableGlobalList from "../components/algolia/SearchableGlobalList.jsx";

export default class SearchableGlobalListModule extends BaseModule {
  init() {
    this.mount = this.el.querySelector("[data-searchable-global-list-mount]");
    if (!this.mount) return;

    const heading = this.mount.dataset.heading || null;

    this.props = {
      heading,
    };
    this.render();
  }

  render() {
    if (!this.mount) return;
    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.mount);
    }
    this.reactRoot.render(createElement(SearchableGlobalList, this.props));
  }

  destroy() {
    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }
  }
}
